import { Navigate, Route, Routes } from 'react-router-dom';
import InvoicingDashboardPage from './InvoicingDashboardPage';
import InvoicesPage from './InvoicesPage';
import PaymentsPage from './PaymentsPage';
import ClientsPage from './ClientsPage';

export default function InvoicingRoutes() {
  return (
    <Routes>
      <Route index element={<InvoicingDashboardPage />} />
      <Route path="invoices" element={<InvoicesPage />} />
      <Route path="payments" element={<PaymentsPage />} />
      <Route path="clients" element={<ClientsPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
